import { render, staticRenderFns } from "./ResultsFunctionality.vue?vue&type=template&id=197a97c4&"
import script from "./ResultsFunctionality.vue?vue&type=script&lang=js&"
export * from "./ResultsFunctionality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports